import { Menu } from "@mantine/core";
import { HeldEmailRowActionsDropdown } from "./HeldEmailRowActionsDropdown";
import { HeldEmailRowActionsTrigger } from "./HeldEmailRowActionsTrigger";
import { HeldEmailRowActionsModel } from "./heldEmailRowActionsModel";

export function HeldEmailRowActionsMenu({
  model,
}: {
  model: HeldEmailRowActionsModel;
}) {
  return (
    <Menu position="bottom-end" offset={8} withinPortal>
      <HeldEmailRowActionsTrigger />
      <HeldEmailRowActionsDropdown model={model} />
    </Menu>
  );
}
